import React, { useState, useEffect } from 'react';
import { getApprovals, approveRequest, rejectRequest, deferRequest } from "../../api/finance";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "https://kanguroo-crm-production.up.railway.app/api/v1";
const api = axios.create({ baseURL: API_BASE });
api.interceptors.request.use((c) => { const t = localStorage.getItem("token"); if (t) c.headers.Authorization = `Bearer ${t}`; return c; });

export default function Approvals() {
  const [approvals, setApprovals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionModal, setActionModal] = useState(null);
  const [note, setNote] = useState('');
  const [deferDate, setDeferDate] = useState('');

  const load = () => {
    setLoading(true);
    getApprovals()
      .then((r) => setApprovals(r.data))
      .catch(() => alert('Onaylar yuklenemedi'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handleApprove = async (id) => {
    try { await approveRequest(id, ''); alert('Onaylandi'); load(); }
    catch (e) { alert(e?.response?.data?.detail || 'Onay basarisiz'); }
  };

  const handleDeleteApproval = async (id) => {
    if (!window.confirm("Onayi silmek istediginizden emin misiniz?")) return;
    try { await api.delete(`/finance/approvals/${id}`); load(); } catch { alert("Silme basarisiz"); }
  };

  const handleModalAction = async () => {
    const { id, type } = actionModal;
    try {
      if (type === 'reject') {
        if (!note) return alert('Red gerekçesi zorunludur');
        await rejectRequest(id, note);
        alert('Reddedildi');
      } else {
        if (!deferDate) return alert('Erteleme tarihi zorunludur');
        await deferRequest(id, deferDate, note);
        alert('Ertelendi');
      }
      setActionModal(null); setNote(''); setDeferDate('');
      load();
    } catch (e) { alert(e?.response?.data?.detail || 'Islem basarisiz'); }
  };

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Bekleyen Onaylar</h1>
          <p className="text-sm text-gray-500 mt-1">Gider ve fatura talepleri</p>
        </div>
        {approvals.length > 0 && (
          <span className="bg-red-100 text-red-700 font-bold text-sm px-3 py-1 rounded-full">{approvals.length} bekliyor</span>
        )}
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-40"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" /></div>
      ) : approvals.length === 0 ? (
        <div className="bg-green-50 border border-green-200 rounded-xl p-12 text-center">
          <p className="text-4xl mb-3">✅</p>
          <p className="text-green-700 font-semibold text-lg">Bekleyen onay yok</p>
          <p className="text-green-600 text-sm mt-1">Tum talepler isleme alindi</p>
        </div>
      ) : (
        <div className="space-y-3">
          {approvals.map((ap) => (
            <div key={ap.id} className="bg-white border border-gray-200 rounded-xl p-5 flex items-start justify-between gap-4 hover:shadow-sm transition">
              <div className="space-y-1 flex-1">
                <div className="flex items-center gap-2">
                  <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${ap.entity_type === 'expense' ? 'bg-orange-100 text-orange-700' : 'bg-blue-100 text-blue-700'}`}>
                    {ap.entity_type === 'expense' ? 'Gider' : 'Fatura Talebi'}
                  </span>
                  <span className="text-xs text-gray-400">#{ap.entity_id.slice(0, 8)}...</span>
                </div>
                <p className="text-sm text-gray-600">Talep: <span className="font-medium">{new Date(ap.requested_at).toLocaleDateString('tr-TR')}</span></p>
              </div>
              <div className="flex gap-2 flex-shrink-0">
                <button onClick={() => handleApprove(ap.id)} className="bg-green-50 text-green-700 border border-green-200 px-4 py-2 rounded-lg text-sm font-medium hover:bg-green-100 transition">Onayla</button>
                <button onClick={() => { setActionModal({ id: ap.id, type: 'defer' }); setNote(''); setDeferDate(''); }} className="bg-yellow-50 text-yellow-700 border border-yellow-200 px-4 py-2 rounded-lg text-sm font-medium hover:bg-yellow-100 transition">Ertele</button>
                <button onClick={() => { setActionModal({ id: ap.id, type: 'reject' }); setNote(''); }} className="bg-red-50 text-red-700 border border-red-200 px-4 py-2 rounded-lg text-sm font-medium hover:bg-red-100 transition">Reddet</button>
                <button onClick={() => handleDeleteApproval(ap.id)} className="bg-gray-50 text-gray-500 border border-gray-200 px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-100 transition">Sil</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {actionModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-md space-y-4">
            <h3 className="text-lg font-bold text-gray-900">{actionModal.type === 'reject' ? 'Reddet' : 'Ertele'}</h3>
            {actionModal.type === 'defer' && (
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">Erteleme Tarihi *</label>
                <input type="date" value={deferDate} onChange={(e) => setDeferDate(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
              </div>
            )}
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">{actionModal.type === 'reject' ? 'Red Gerekçesi *' : 'Not (opsiyonel)'}</label>
              <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={3}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Gerekce yazin..." />
            </div>
            <div className="flex gap-3 justify-end">
              <button onClick={() => setActionModal(null)} className="px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50 transition">Iptal</button>
              <button onClick={handleModalAction}
                className={`px-5 py-2 rounded-lg text-sm font-medium text-white transition ${actionModal.type === 'reject' ? 'bg-red-600 hover:bg-red-700' : 'bg-yellow-500 hover:bg-yellow-600'}`}>
                {actionModal.type === 'reject' ? 'Reddet' : 'Ertele'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
